import { TipsAndUpdates } from '@mui/icons-material'
import { Box, Typography, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import '../i18n'
import { useCompanySpaces } from '../queries/useCompanyQueries'
import { useUI } from '../hooks/useUI'

const TableLayout = ({ children, countryCode }: { children: any; countryCode?: any }) => {
  const { t } = useTranslation()
  const { darkMode } = useUI()
  const { data: companyData } = useCompanySpaces()

  const companyInfo = companyData?.body?.content[0]

  return (
    <Box className={darkMode ? 'text-gray-100' : 'text-gray-900'}>
      <Typography
        variant="h6"
        textAlign={'center'}
        color="primary.main"
        fontWeight={'bold'}
        mb={2}
        mt={2}
      >
        {t('depositReception')}
      </Typography>
      <Grid container spacing={3} mb={2}>
        <Grid item>
          <Typography color="primary.main" fontWeight={'bold'}>
            {t('toName')}:
          </Typography>
          <Typography color="primary.main" fontWeight={'bold'}>
            {t('reportToEmail')}:
          </Typography>
          <Typography color="primary.main" fontWeight={'bold'}>
            {t('phone')}:
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
            {companyInfo?.description}
          </Typography>
          <Typography className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
            {companyInfo?.mail}
          </Typography>
          <Typography className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
            ({countryCode}) {companyInfo?.phone}
          </Typography>
        </Grid>
      </Grid>

      {children}
      <Box mt={4} textAlign={'center'}>
        <Typography variant="body2" className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
          {t('sendProofFollowingMedia')}:{' '}
          <TipsAndUpdates className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
        </Typography>
        <Box sx={{ py: 0 }}>
          <Typography color="primary.main" fontWeight={'bold'} variant="body2" component={'span'}>
            {t('email')}:{' '}
          </Typography>
          <Typography
            variant="body2"
            component={'span'}
            className={darkMode ? 'text-gray-300' : 'text-gray-700'}
          >
            {companyInfo?.mail}
          </Typography>
        </Box>
        <Box sx={{ py: 0 }} />
      </Box>
    </Box>
  )
}

export default TableLayout
